import { NavigateOptions, useNavigate } from "react-router-dom";
import { useFamaFlags } from "../api/FamaFlags";

const useNavigateNewPerson = () => {
  const navigate = useNavigate();
  const flags = useFamaFlags();
  function navigateCreatePerson(options?: NavigateOptions | undefined) {
    if (flags.useReportWizard) {
      navigate("/reports-wizard", options);
      return;
    }
    if (flags.enableAddPersonMulticheckType) {
      navigate("/person/newmulti", options);
      return;
    }
    navigate("/person/new", options);
  }
  return { navigateCreatePerson };
};

export default useNavigateNewPerson;
